import { Box, useTheme } from '@mui/material';
import {
  moodContainerSx,
  moodLabelSx,
  summaryBannerContainerSx,
  summaryContainerSx,
  totalDistanceTextSx,
} from './SummaryBanner.style';
import { Text } from '../Text/Text';
import { transformMood } from '../../helpers/transformMood';
import { font700Sx } from '../../styles/Global.style';
import { Copy } from '../../copy/Copy';

export const SummaryBanner = ({ averageMood, firstName, totalDistance }) => {
  const theme = useTheme();

  return (
    <Box component="section" sx={summaryBannerContainerSx(theme)}>
      {averageMood > 0 && (
        <Box sx={moodContainerSx}>
          {transformMood(averageMood, theme.palette.tertiary.main)}

          <Text
            variant="body2"
            text={Copy.generate('SummaryBanner.avgMood')}
            sx={moodLabelSx}
          />
        </Box>
      )}

      <Box sx={summaryContainerSx}>
        <Text variant="body2" text={`Hi ${firstName}`} sx={font700Sx} />
        <Text
          variant="body2"
          text={`${totalDistance ? totalDistance : 0} miles`}
          sx={totalDistanceTextSx(theme)}
        />
      </Box>
    </Box>
  );
};
